import { describeResource } from '@siteless/resource';
import { collection, getDocs } from 'firebase/firestore';
import { database } from '../../config/firebase';
import { thisOscarsYear } from '../../config/constants';

let BallotsScoresResource = describeResource('BallotsScoresResource', {
  get: async () => {
    let scores: Record<string, { score: number; strictScore: number }> = {};

    (await getDocs(collection(database, 'derived_state', String(thisOscarsYear), 'scores'))).forEach(
      document => {
        let data = document.data();
        if (data?.score === undefined || data?.strictScore === undefined) return;
        scores[document.id] = {
          score: data.score,
          strictScore: data.strictScore,
        };
      },
    );
    return scores;
  },
});

export default BallotsScoresResource;
